export default __webpack_public_path__ + "static/media/7minfitness@3x.f7f06a0e.jpg";